<template>
  <router-link
    v-if="record.accessToPersonal"
    class="referrals-link-to-brought-employee"
    :to="{ name: 'personal-employee-referrals', params: { id: record.workerId } }"
    target="_blank"
  >
    {{ cellValue }}
  </router-link>
  <div v-else class="referrals-brought-employee-name">
    {{ cellValue }}
  </div>
</template>

<script>
export default {
  name: "referrals-link-to-brought-employee",
  props: ["record", "cellValue"],
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.referrals-link-to-brought-employee {
  line-height: 13px;
  font-size: 13px;
  padding: 10px !important;
  color: #0066ff;
  line-height: 100%;
  cursor: pointer;
  -webkit-transition: font 0.3s ease;
  text-align: left;
  transition: font 0.3s ease;

  &:hover {
    text-decoration: none;
    color: #003f9d;
  }
}
.referrals-brought-employee-name {
  line-height: 13px;
  font-size: 13px;
  padding: 10px !important;
  -webkit-transition: font 0.3s ease;
  transition: font 0.3s ease;
}
</style>
